<template>
  <path
    d="M9.00002 16.1996L4.80002 11.9996L3.40002 13.3996L9.00002 18.9996L21 6.99961L19.6 5.59961L9.00002 16.1996Z"
  />
</template>
